import { axiosServices } from "./axiosServices";

export const qcServices = { getQCListing, getQCProductList, createQC, updateQC };

function getQCListing(param) {
    return axiosServices.getAxios(`/v1/common/quality-checks${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getQCProductList(qcId, param) {
    return axiosServices.getAxios(`/v1/common/quality-checks/${qcId}/products${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function createQC(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/quality-checks", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateQC(qcId, bodyData) {
    return axiosServices
        .putAxios(`/v1/internal/quality-checks/${qcId}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}
